import { render, staticRenderFns } from "./SenderEmployeeSelectView.vue?vue&type=template&id=b5522a18&scoped=true&"
import script from "./SenderEmployeeSelectView.vue?vue&type=script&lang=js&"
export * from "./SenderEmployeeSelectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5522a18",
  null
  
)

export default component.exports